module.exports = __webpack_public_path__ + "static/media/logo.1a97abb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 961
// module chunks = 0